import { render } from "./DiscoverComp.vue?vue&type=template&id=311a6def&scoped=true"
const script = {}

import "./DiscoverComp.vue?vue&type=style&index=0&id=311a6def&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-311a6def"]])

export default __exports__